import { Button, Grid, Card, ReadOnlySection } from '@cxc/react-fpds-components';
import styles from './Summary.module.scss';
import Modal from '../Modal/Modal';
import { PopUp } from '@cxc/react-fpds-icons-v1';
import { useState } from 'react';
import { ButtonPlacementType, SUMMARY_PAGE_MODAL_DATA } from '../../constants/SummaryConstants';
import { formatCapitalizeFirstLetters, getColorBasedOnStatus } from '../../utils/utils';
import ResidentialSummaryProps from '../../types/props/ResidentialSummaryProp';
import {
    getApplicableVehicleType,
    getResidentialIncentiveStatus,
    getResidentialIncentiveApplicableType,
} from '../../utils/ResidentialIncentivesDataHelpers';

const ResidentialSummary = ({ residentialIncentive }: ResidentialSummaryProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const rowGap = 20;

    return (
        <>
            <Grid rowGap={rowGap} style={{ marginTop: '2rem' }}>
                <Grid.Item xl={12} l={12} m={12} s={12}>
                    <Grid rowGap={20}>
                        <Grid.Item>
                            <Card
                                className={styles.cardTagStyles}
                                titleProp={{
                                    title: (
                                        <span
                                            style={{
                                                color: `${getColorBasedOnStatus(
                                                    getResidentialIncentiveStatus(
                                                        residentialIncentive.available,
                                                    ),
                                                )}`,
                                            }}
                                        >
                                            {formatCapitalizeFirstLetters(
                                                getResidentialIncentiveStatus(
                                                    residentialIncentive.available,
                                                ),
                                            )}
                                        </span>
                                    ),
                                    headingLevel: 'h1',
                                    size: 'large',
                                }}
                            >
                                <Card.Tag title="Status" />
                            </Card>
                        </Grid.Item>

                        <Grid.Item>
                            <Card
                                className={styles.cardTagStyles}
                                titleProp={{
                                    title: (
                                        <span style={{ color: '#00142E' }}>
                                            {formatCapitalizeFirstLetters(
                                                residentialIncentive.grantorType,
                                            )}
                                        </span>
                                    ),
                                    headingLevel: 'h1',
                                    size: 'large',
                                }}
                            >
                                <Card.Tag title="Grantor" />
                                <Card.Footer>
                                    <Card.SubTitle headingLevel="h2">
                                        {residentialIncentive.grantorName}
                                    </Card.SubTitle>
                                </Card.Footer>
                            </Card>
                        </Grid.Item>

                        <Grid.Item>
                            <Card
                                className={styles.cardTagStyles}
                                titleProp={{
                                    title: residentialIncentive.typicalAmount,
                                    headingLevel: 'h6',
                                    size: 'large',
                                }}
                            >
                                <Card.Tag title="Potential Amount" />
                            </Card>
                        </Grid.Item>

                        <Grid.Item>
                            <Card
                                className={styles.cardTagStyles}
                                titleProp={{
                                    title: getResidentialIncentiveApplicableType(
                                        residentialIncentive.pointOfSale,
                                    ),
                                    headingLevel: 'h6',
                                    size: 'large',
                                }}
                            >
                                <Card.Tag title="Applicability" />
                            </Card>
                        </Grid.Item>
                    </Grid>
                </Grid.Item>

                <Card className={styles.cardTagStyles}>
                    <Grid.Item xl={12} l={12} m={12} s={12}>
                        <ReadOnlySection
                            header={{
                                title: 'GENERAL INFORMATION',
                                subTitle: '',
                            }}
                            variant="SuperCondensed"
                            columnOptions={{ xl: 6, l: 6, m: 6, s: 12 }}
                        >
                            <ReadOnlySection.Item
                                label="Name"
                                value={residentialIncentive.incentiveName}
                            />
                            <ReadOnlySection.Item
                                label="Description"
                                value={residentialIncentive.description}
                            />
                            <ReadOnlySection.Item
                                label="Purchase Type"
                                value={residentialIncentive.type}
                            />
                        </ReadOnlySection>
                    </Grid.Item>

                    <Grid.Item xl={12} l={12} m={12} s={12} style={{ marginTop: '20px' }}>
                        <Button style={{ gap: '16px' }} onClick={() => setIsOpen(true)}>
                            Visit Grantor Site <PopUp size={'s'} />
                        </Button>
                        <Modal
                            title={SUMMARY_PAGE_MODAL_DATA.TITLE}
                            buttons={SUMMARY_PAGE_MODAL_DATA.BUTTONS}
                            buttonPlacement={ButtonPlacementType.right}
                            description={SUMMARY_PAGE_MODAL_DATA.DESCRIPTION}
                            isOpen={isOpen}
                            setIsOpen={setIsOpen}
                            headingLevel={'h1'}
                            variant={'large'}
                            url={residentialIncentive.detailsUrl}
                        />
                    </Grid.Item>
                </Card>

                <Card className={styles.cardTagStyles}>
                    <ReadOnlySection
                        header={{
                            title: 'VEHICLE ELIGIBILITY',
                            subTitle: '',
                        }}
                        variant="SuperCondensed"
                        columnOptions={{ xl: 6, l: 6, m: 6, s: 12 }}
                    >
                        <ReadOnlySection.Item label="Vehicle Type" value="Onroad" />
                        <ReadOnlySection.Item label="Vehicle Segments" value="Passenger" />
                        <ReadOnlySection.Item
                            label="Vehicle Fuel Types"
                            value="Battery-Electric, Plug-in Hybrid"
                        />
                        <ReadOnlySection.Item
                            label="Vehicle Description"
                            value={getApplicableVehicleType(residentialIncentive)}
                        />
                    </ReadOnlySection>
                </Card>
            </Grid>
        </>
    );
};

export default ResidentialSummary;
